import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const SUBSCRIPTION_STORAGE_KEY = 'subscription';

interface SubscriptionState {
  subscription: any;
}

const initialState: SubscriptionState = {
  subscription: null,
};

export const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    setMySubscription: (state, action: PayloadAction<any>) => {
      state.subscription = action.payload;
      localStorage.setItem(SUBSCRIPTION_STORAGE_KEY, JSON.stringify(state));
    },
    getMySubscription: state => {
      const data = localStorage.getItem(SUBSCRIPTION_STORAGE_KEY);
      if (data) {
        const parsed = JSON.parse(data);
        state.subscription = parsed.subscription;
      }
    },
  },
});

export const { setMySubscription, getMySubscription } =
  subscriptionSlice.actions;

export const selectSubscription = (state: any) => state.subscription.subscription;

export default subscriptionSlice.reducer;

